import { useModal } from '@flecto/ui'

import { ModalBookingProductsSelection, type ModalBookingProductsSelectionProps } from '../components/ModalBookingProductsSelection/ModalBookingProductsSelection'

export type UseModalBookingProductsSelectionProps = ModalBookingProductsSelectionProps

export function useModalBookingProductsSelection(
  params: UseModalBookingProductsSelectionProps
) {
  return useModal(<ModalBookingProductsSelection {...params} />)
}
